<template>
  <div>
    <section class="service-title-wrap">
      <h4 class="service-title">{{ $t('menuService.culture') }}</h4>
      <div class="service-title-sub">{{ $t('culture.headCopy') }}</div>
    </section>

    <section>
      <div class="service-item" :data-id="$t('culture.store.name')">
        <h5 :id="$t('culture.store.name')">{{ $t('culture.store.name') }}</h5>
        <div class="service-item-image">
          <picture>
            <source media="(min-width: 750px)" srcset="~@/static/image/service/pc/store@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/service/m/store@3x.jpg 3x">
            <img src="~@/static/image/service/pc/store.jpg" :alt="$t('culture.store.name')">
          </picture>
        </div>
        <div class="service-item-title">
          <img
            src="~@/static/image/logo-family/logo_store.png"
            srcset="~@/static/image/logo-family/logo_store@2x.png 2x, ~@/static/image/logo-family/logo_store@3x.png 3x"
            :alt="$t('culture.store.name')"
          >
          <html-view tag="p" :value="$t('culture.store.title')" />
        </div>
        <div class="service-item-content">
          <html-view :value="$t('culture.store.content')" />
          <div class="btn-go-site"><a href="https://store.baemin.com/" class="btn-blank" target="_blank">{{ $t('culture.store.site') }}<icon-blank /></a></div>
        </div>
      </div>
      <div class="service-item" :data-id="$t('culture.cartoon.name')">
        <h5 :id="$t('culture.cartoon.name')">{{ $t('culture.cartoon.name') }}</h5>
        <div class="service-item-image">
          <picture>
            <source media="(min-width: 750px)" srcset="~@/static/image/service/pc/cartoon@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/service/m/cartoon@3x.jpg 3x">
            <img src="~@/static/image/service/pc/cartoon.jpg" :alt="$t('culture.cartoon.name')">
          </picture>
        </div>
        <div class="service-item-title">
          <img
            src="~@/static/image/logo-family/logo_cartoon.png"
            srcset="~@/static/image/logo-family/logo_cartoon@2x.png 2x, ~@/static/image/logo-family/logo_cartoon@3x.png 3x"
            :alt="$t('culture.cartoon.name')"
          >
          <html-view tag="p" :value="$t('culture.cartoon.title')" />
        </div>
        <div class="service-item-content">
          <html-view :value="$t('culture.cartoon.content')" />
          <div class="btn-go-site"><a href="https://www.manhwakyung.com/main" class="btn-blank" target="_blank">{{ $t('culture.cartoon.site') }}<icon-blank /></a></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  components: {
    iconBlank: () => import('@/static/svg/blank.svg')
  },
}
</script>
